import { FeatureData } from '../../components/ui/feature-section-with-hoover-effect';
import {
  IconAffiliate,
  IconBinaryTree2,
  IconUserShield,
  IconBrandAzure,
} from '@tabler/icons-react';

const formationAFFeatures: FeatureData[] = [
  {
    title: '',
    description: '',
    icon: <IconAffiliate size={24} />,
    key: "formationAF.features.1",
  },
  {
    title: '',
    description: '',
    icon: <IconBinaryTree2 size={24} />,
    key: 'formationAF.features.2'
  },
  {
    title: '',
    description: '',
    icon: <IconUserShield size={24} />,
    key: 'formationAF.features.3'
  },
  {
    title: '',
    description: '',
    icon: <IconBrandAzure size={24} />,
    key: 'formationAF.features.4'
  },
];

export default formationAFFeatures; 